import type { TFunction } from "i18next";

import { z } from "zod";

const str = (s: string | null): string => s ?? "";
const opportunitySongListItemSchema = z.object({
  workcode: z.string().trim().min(1, "Please select a valid work."),
  title: z.string(),
  performingartists: z.string().optional(),
  label: z.string().optional(),
});

export function createOpportunitiesApplySchema(t: TFunction) {
  return z.object({
    opp: z.string().min(1, t("regex:choose-opportunity-error", "Please choose an opportunity.")),
    songList: z
      .array(opportunitySongListItemSchema)
      .min(5, str(t("regex:add-five-songs-error", "Please add at least 5 songs."))),
    content: z.string().optional(),
  });
}

export type OpportunitiesApplyFormData = z.infer<ReturnType<typeof createOpportunitiesApplySchema>>;
